import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FileUploadComponent } from "../../common/file-upload/file-upload.component";

/**
 * The `UploadTestCaseDocComponent` handles the uploading of different documents related to test cases.
 * It manages file selections, dropdown selections, and repository link input for various types of documents.
 * The component also collects all selected data upon navigating to the next step.
 */
@Component({
  selector: "app-upload-test-case-doc",
  standalone: true,
  imports: [FileUploadComponent, CommonModule, FormsModule],
  templateUrl: "./upload-test-case-doc.component.html",
  styleUrl: "./upload-test-case-doc.component.scss",
})
export class UploadTestCaseDocComponent {
  selectedOption: any;
  sectionData: any;
  files: any;
  repoLink: string = "";

  constructor(@Inject("STEP_DATA") public data: any) {}

  uploadTestCaseData: any = [
    {
      id: 1,
      title: "Upload SRS Document",
      dropDownLabel: "Select Upload Type",
      dropDownOptions: ["SRS", "BRD"],
      selectedOption: "SRS",
      uploadFile: {
        fileUploadLabel: "Upload SRD (or) BRD document",
        fileTypes: ".doc, .docx, .pdf",
        buttonLabel: "Choose file",
        placeholderText: "SRS (or) BRD files only",
      },
    },
    {
      id: 2,
      title: "Upload Test Case Document",
      dropDownLabel: "Select Versioning of Test Cases",
      selectedOption: "Test Pack version 1",
      dropDownOptions: [
        "Test Pack version 1",
        "Test Pack version 2",
        "Test Pack version 3",
      ],
      infoUrl: "test",
      uploadFile: {
        fileUploadLabel: "Upload Test Case Document (csv)",
        fileTypes: ".csv",
        buttonLabel: "Choose file",
        placeholderText: "csv files only",
      },
    },
    {
      id: 3,
      title: "Upload Test Case Scripts",
      inputLabel: "Enter GitHub Repo Link",
      repoLink: "https://github.com/shashirajraja/shoppin",
    },
    {
      id: 4,
      title: "Upload Automated Standard Document",
      uploadFile: {
        fileUploadLabel: "Upload Automated Standard Document",
        fileTypes: ".csv",
        buttonLabel: "Choose file",
        placeholderText: "Csv files only",
      },
    },
  ];

  /**
   * Handles the change event for the dropdown. It updates the `selectedOption` property with the selected value.
   * @param event - The event triggered when a dropdown value changes.
   * @param data - The associated data object for the dropdown.
   */
  onDropdownChange(event: any, data: any): void {
    const target = event.target as HTMLSelectElement;
    this.selectedOption = target.value;
  }

  /**
   * Handles the file selection event. It updates the `files` property with the selected files and stores them in the provided data.
   * @param event - The event triggered when files are selected.
   * @param data - The associated data object where the selected files will be stored.
   */
  handleFilesSelected(event: any, data: any) {
    this.files = event.files;
    data.selectedFiles = this.files;
  }

  /**
   * Handles changes to the GitHub repository link input.
   * Logs the repository link for the selected test case script.
   * @param data - The data associated with the current section, including the repo link.
   */
  onRepoLinkChange(data: any): void {
    console.log(`Repo link for ID ${data.id}:`, data.repoLink);
  }

  //on next click, get all the data
  getAllSelectedData(): void {
    const result = this.uploadTestCaseData.map((item: any) => ({
      id: item.id,
      selectedOption: item.selectedOption,
      selectedFiles: item.selectedFiles,
      repoLink: item.repoLink,
    }));
    console.log("All Selected Data:", result);
  }
}
